import { render, staticRenderFns } from "./show-detail.vue?vue&type=template&id=69d9d621&scoped=true&"
import script from "./show-detail.vue?vue&type=script&lang=js&"
export * from "./show-detail.vue?vue&type=script&lang=js&"
import style0 from "./show-detail.vue?vue&type=style&index=0&id=69d9d621&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d9d621",
  null
  
)

export default component.exports